import PropTypes from 'prop-types';
import React from 'react';
import Select from '@loggi/ui/components/select';
import styles from './index.scss';

class Disambiguation extends React.Component {
  static displayName = 'Disambiguation';

  static propTypes = {
    onDisambiguationSelected: PropTypes.func
  };

  constructor(props) {
    super(props);

    this._onAddressClick = this._onAddressClick.bind(this);
    this._clearDisambiguation = this._clearDisambiguation.bind(this);
  }

  render() {
    const { geocodes } = this.props;
    const options = geocodes.map(geocode => ({
      label: geocode.formattedAddress,
      value: geocode
    }));

    return (
      <Select
        className={styles.disambiguation}
        opened
        placeholder="Confirme um dos endereços abaixo"
        options={options}
        onChange={this._onAddressClick}
        onClose={this._clearDisambiguation}
      />
    );
  }

  _onAddressClick(geocode) {
    const { onDisambiguationSelected } = this.props;

    onDisambiguationSelected(geocode);
  }

  _clearDisambiguation() {
    const { onDisambiguationSelected } = this.props;

    onDisambiguationSelected(null);
  }
}

export default Disambiguation;
